import { usePublicationsFeaturedListComposedGeolocation } from '../publications/publications.store';
import {
  PublicationListContainer,
  StyledScrollSection,
  StyledSection,
} from '../../components/layouts/Layouts';
import { SkeletonHomePublicationFeaturedList } from './SkeletonHomePublicationFeaturedList';
import { HomePublicationFeaturedListItem } from './HomePublicationFeaturedListItem';
import { TextHeading2 } from '@ferreri/prever-component-lib';

export const HomePublicationFeaturedList = () => {
  const {
    data: publicationList,
    isLoading,
    isEmpty,
  } = usePublicationsFeaturedListComposedGeolocation();

  if (isLoading) return <SkeletonHomePublicationFeaturedList />;

  if (isEmpty) return null;

  return (
    <>
      <StyledSection>
        <TextHeading2>Benefícios em destaque</TextHeading2>
      </StyledSection>
      <StyledScrollSection>
        <PublicationListContainer>
          {publicationList?.map((publication) => (
            <HomePublicationFeaturedListItem
              key={publication?.id}
              publication={publication}
            />
          ))}
        </PublicationListContainer>
      </StyledScrollSection>
    </>
  );
};
